import { Interfaces } from '../../actions/values';
import { IValues } from '../../interfaces';
import { RESOURCE_FIELD_TYPE } from '@logicmanager/common';
import { ActionTypes } from '../../actions/values/constants';
export type ActionType = Interfaces.IUpdateValue
  | Interfaces.ILoadDefaultValue
  | Interfaces.IUpdateLinkType
  | Interfaces.ILoadDefaultTableValues
  | Interfaces.IUpdateTableValues
  | Interfaces.IUpdateCaptchaResponse
  | Interfaces.IUpdateValues;

const initial: IValues = {
    fields: {},
    captchaResponse: null
};

export function values(state: IValues = initial, action: ActionType): IValues {
    switch (action.type) {
        case ActionTypes.UPDATE_VALUES:
            return {
                ...state,
                fields: { ...state.fields, ...action.fieldValues }
            };
        case ActionTypes.UPDATE_VALUE:
            return {
                ...state,
                fields: {
                    ...state.fields,
                    [action.id]: {
                        ...state.fields[action.id],
                        ...action.fieldValue
                    }
                }
            };
        case ActionTypes.LOAD_DEFAULT_VALUE:
            const {id, tabId, fieldType, value, visible} = action.fieldValue;
            return {
                ...state,
                fields: {
                    ...state.fields,
                    [id]: {
                        ...state.fields[id],
                        id,
                        tabId,
                        fieldType,
                        value: value || '',
                        valid: true,
                        visible
                    }
                }
            };
        case ActionTypes.UPDATE_LINK_TYPE:
            return {
                ...state,
                fields: {
                    ...state.fields,
                    [action.id]: {
                        ...state.fields[action.id],
                        linkType: action.linkType
                    }
                }
            };
        case ActionTypes.LOAD_DEFAULT_TABLE_VALUES:
            return {
                ...state,
                fields: {
                    ...state.fields,
                    [action.id] : {
                        ...state.fields[action.id],
                        id: action.id,
                        fieldType: RESOURCE_FIELD_TYPE.TABLE,
                        tabId: action.tabId,
                        required: action.required,
                        tableItems: action.tableItems,
                        valid: true,
                        visible: action.visible
                    }
                }
            };
        case ActionTypes.UPDATE_TABLE_VALUES:
            return {
                ...state,
                fields: {
                    ...state.fields,
                    [action.id] : {
                        ...state.fields[action.id],
                        tableItems: action.tableValues
                    }
                }
            };
        case ActionTypes.UPDATE_CAPTCHA_RESPONSE:
            return {
                ...state,
                captchaResponse: action.response
            };
            default:
                return state;
    }
}
